import Vue from 'vue'
import Router from 'vue-router'
import VueCarousel from 'vue-carousel'
import VueAgile from 'vue-agile'

import Home from '@/components/home/home'
import Message from '@/components/message/Message'

import Sportsbook from '@/components/sportsbook/fixture'
import TodayMatches from '@/components/sportsbook/today'
import SportsbookLive from '@/components/sportsbook/live'

import Promotion from '@/components/promotion/list'
import Account from '@/components/user/account/home'
import userDashboard from '@/components/user/account/dashboard'
import prefences from "../components/user/account/prefences";

import Register from '@/components/user/registration'
import withdraw from '@/components/user/transactions/withdraw'
import MyBets from '@/components/user/account/myBets'
import transactionHome from '@/components/user/transactions/home'
import transactionWithdraw from '@/components/user/transactions/transactionWithdraw'
import transactionDeposit from '@/components/user/transactions/transactionDeposit'

import limitHistory from '@/components/user/account/limitHistory'
import Payments from '@/components/payments/payments'
import sendMoney from '@/components/transfer/sendMoney'
import errorReseller from  '@/components/transfer/errorReseller'
import changePassword from '@/components/user/form/changePassword'
import bankStatement from '@/components/user/bankStatement'

import userInfo from '@/components/user/userInfo'
import limits from '@/components/user/limits'

import CasinoGame from '@/components/casino/game'
import LiveCasino from '@/components/casino/live'
import Tombola from '@/components/casino/tombola'
import Login from  '@/components/auth/login'

Vue.use(VueAgile)
Vue.use(Router)
Vue.use(VueCarousel)

var locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');

export default new Router({
    base: (locale.trim().length && locale != "/") ? '/' + locale : '/'+window.defaultLocale+'/',
    mode: 'history',
    routes: [
        {
            path: '/',
            pathX: '/',
            name: 'Home',
            component: Home,
            lang: 'pre_bets',
            main: 0,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Home'
            }
        },

        /*{
            path: '/message',
            name: 'Message',
            main: 0,
            component: Message,
            meta: {
                mainMenu: 0,
                breadcrumb: 'Message'
            }
        },
        {
            path: '/user-agreement',
            name: 'UserAgreement',
            main: 0,
            component: Message,
            meta: {
                mainMenu: 0,
                breadcrumb: 'Message'
            }
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicy',
            main: 0,
            component: Message,
            meta: {
                mainMenu: 0,
                breadcrumb: 'Message'
            }
        },
        {
            path: '/conversation/:id?',
            name: 'conversation',
            main: 0,
            component: Message
        },
        {
            path: ':locale?/u/:id',
            name: 'userprofile',
            main: 0,
            component: Message
        },*/

        {
            path: '/highlighted/:event?',
            pathX: 'sportsbook/',
            name: 'highlighted',
            lang: 'pre_bets',
            main: 0,
            icon: 'icon-social-dribbble',
            component: TodayMatches,
            params: {},
            meta: {
                mainMenu: 1,
                breadcrumb: 'Sportsbook'
            },
        },
        {
            path: '/today/:event?',
            pathX: 'sportsbook/',
            name: 'today',
            lang: 'pre_bets',
            main: 0,
            icon: 'icon-social-dribbble',
            component: TodayMatches,
            params: {},
            meta: {
                mainMenu: 1,
                breadcrumb: 'Sportsbook'
            },
        },
        {
            path: '/sportsbook/:event?',
            pathX: 'sportsbook/',
            name: 'Sportsbook',
            lang: 'pre_bets',
            main: 1,
            icon: 'icon-social-dribbble',
            component: Sportsbook,
            params: {},
            meta: {
                mainMenu: 1,
                breadcrumb: 'Sportsbook'
            },
        },
        {
            path: '/my-favorites/:event?',
            pathX: 'myFavorites',
            name: 'myFavorites',
            lang: 'pre_bets',
            main: 0,
            icon: 'icon-social-dribbble',
            component: Sportsbook,
            params: {},
            meta: {
                mainMenu: 0,
                breadcrumb: 'Sportsbook'
            },
        },
        {
            path: '/event/:event?',
            pathX: '/event/',
            name: 'SportsbookEvent',
            lang: 'pre_bets',
            main: 0,
            icon: 'icon-social-dribbble',
            component: Sportsbook,
            params: {},
            meta: {
                mainMenu: 0,
                breadcrumb: 'Sportsbook'
            },
        },
        {
            path: '/live/:sport?/:event?',
            pathX: '/live-betting/0',
            name: 'LiveBets',
            lang: 'live_bets',
            main: 1,
            icon: 'icon-fire minute_counter',
            component: SportsbookLive,
            meta: {
                mainMenu: 1,
                breadcrumb: 'LiveBets'
            },
            subRoutes: {
                '/': {
                    // Bar will be rendered inside Foo's <router-view>
                    // when /foo/bar is matched
                    component: SportsbookLive
                },
            }
        },
        {
            path: '/:locale?/casino/:game?',
            pathX: '/casino/',
            name: 'Casino',
            lang: 'casino',
            main: 1,
            icon: 'icon-diamond',
            component: CasinoGame,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Casino',
                isLive: false
            },
            subRoutes: {
                '/': {
                    // Bar will be rendered inside Foo's <router-view>
                    // when /foo/bar is matched
                    component: CasinoGame
                },
            }
        },
        {
            path: '/:locale?/live-casino/:game?',
            pathX: '/live-casino/',
            name: 'LiveCasino',
            lang: 'live_casino',
            main: 1,
            icon: 'icon-heart',
            component: LiveCasino,
            meta: {
                mainMenu: 1,
                breadcrumb: 'LiveCasino',
                isLive: true
            }
        },
        {
            path: '/:locale?/live-games/:game?',
            pathX: '/live-games/',
            name: 'Live Games',
            lang: 'live_games',
            main: 0,
            component: CasinoGame,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Casino',
                isLive: 1
            }
        },
        {
            path: '/:locale?/live-tombola/:game?',
            pathX: '/live-tombola/',
            name: 'Live Tombola',
            lang: 'live_tombola',
            main: 0,
            component: Tombola,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Casino',
                isLive: 1
            }
        },
        {
            path: '/payments/:method?/:withdraw?',
            pathX: '/payments/',
            name: 'Payments',
            lang: 'payments',
            main: 0,
            component: Payments,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Payments'
            }
        },
        {
            path: '/error/reseller',
            pathX: '/sendMoney/',
            name: 'error_payment_reseller',
            lang: 'error_reseller',
            main: 0,
            component: errorReseller,
            meta: {
                mainMenu: 1,
                breadcrumb: 'errorReseller'
            }
        },
        {
            path: '/sendMoney',
            pathX: '/sendMoney/',
            name: 'SendMoney',
            lang: 'sendmoney_to_friends',
            main: 0,
            component: sendMoney,
            meta: {
                mainMenu: 1,
                breadcrumb: 'SendMoney'
            }
        },
        {
            path: '/:locale?/promotions/:id?',
            pathX: '/promotions/',
            name: 'Promotions',
            lang: 'promotions',
            main: 1,
            icon: 'icon-present',
            component: Promotion,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Promotions'
            },
            subRoutes: {
                '/': {
                    // Bar will be rendered inside Foo's <router-view>
                    // when /foo/bar is matched
                    component: Promotion
                },
            }
        },
        {
            path: '/:locale?/register',
            name: 'Register',
            lang: 'register',
            component: Register,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Register'
            },
            subRoutes: {
                '/': {
                    // Bar will be rendered inside Foo's <router-view>
                    // when /foo/bar is matched
                    component: Register
                },
            }
        },
        {
            path: '/login',
            name: 'Login',
            lang: 'login',
            component: Login,
            meta: {
                mainMenu: 1,
                breadcrumb: 'Login'
            },
        },
        {
            // UserProfile will be rendered inside User's <router-view>
            path: '/my-bets',
            component: MyBets,
            name: 'my_bets',
            meta: {
                mainMenu: 1,
                breadcrumb: 'personal_informations'
            },
        },
        {
            path: '/account',
            name: 'Account',
            lang: 'account',
            main: 0,
            component: Account,
            meta: {
                mainMenu: 1,
                breadcrumb: 'account'
            },
            children: [
                {
                    path: '/limitations',
                    component: limits,
                    name: 'limitations',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'personal_informations'
                    },
                },
                {
                    path: '/',
                    component: userDashboard,
                    name: 'user_dashboard',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'personal_informations'
                    },
                },
                {
                    path: 'settings',
                    component: prefences,
                    name: 'settings',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'settings'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: 'change-password',
                    component: changePassword,
                    name: 'change_password',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'change_password'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: 'promotions',
                    component: Promotion,
                    name: 'promotions',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'promotions'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: '/messages',
                    component: Message,
                    name: 'messages',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'messages'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: 'personal-informations',
                    component: userInfo,
                    name: 'personal_informations',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'personal_informations'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: 'payments',
                    component: Payments,
                    name: 'my_payments',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'payments'
                    },
                },
                {
                    // UserProfile will be rendered inside User's <router-view>
                    path: 'bank-accounts',
                    component: bankStatement,
                    name: 'bank_accounts',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'bank_accounts'
                    },
                },
                {
                    path: 'limit-history',
                    component: limitHistory,
                    name: 'limit_history',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'limit_history'
                    },
                },
                {
                    path: '/transactions',
                    component: transactionHome,
                    name: 'transactions',
                    meta: {
                        mainMenu: 1,
                        breadcrumb: 'transactions'
                    },
                    children: [
                        {
                            path: 'deposit',
                            component: transactionDeposit,
                            name: 'deposit_transactions',
                            meta: {
                                mainMenu: 1,
                                breadcrumb: 'deposit_transactions'
                            },
                        },
                        {
                            path: 'withdraw',
                            component: transactionWithdraw,
                            name: 'withdraw_transactions',
                            meta: {
                                mainMenu: 1,
                                breadcrumb: 'withdraw_transactions'
                            },
                        },
                        {
                            path: 'create-withdraw',
                            component: withdraw,
                            name: 'withdraw_money',
                            meta: {
                                mainMenu: 1,
                                breadcrumb: 'withdraw_money'
                            },
                        },
                    ]
                },
            ]
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js